import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { dataFileUrl } from '../../common/api';
import { Icon } from '../../common/AppShell';

const Main = () => {
  const [available, setAvailable] = useState(null);
  const [menuData, setMenuData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    Promise.all([
      axios.get(`${dataFileUrl('available')}?t=${Date.now()}`).then((response) => response.data),
      axios.get(`${dataFileUrl('data')}?t=${Date.now()}`).then((response) => response.data),
    ])
      .then(([availableData, menu]) => {
        setAvailable(availableData);
        setMenuData(menu);
      })
      .catch(() => {
        setAvailable({ isNotAvailable: false });
      });
  }, []);

  const stats = useMemo(() => {
    const categories = menuData ? Object.keys(menuData).length : 0;
    const items = menuData
      ? Object.values(menuData).reduce((total, categoryItems) => total + categoryItems.length, 0)
      : 0;

    return { categories, items };
  }, [menuData]);

  const sections = [
    { path: '/menu', icon: 'restaurant_menu', title: 'Меню', description: 'Блюда, цены, стоп-лист' },
    { path: '/contacts', icon: 'call', title: 'Контакты', description: 'Адрес, телефон, режим работы' },
    { path: '/delivery', icon: 'local_shipping', title: 'Доставка', description: 'Тарифы, часы, условия' },
    { path: '/available', icon: 'health_and_safety', title: 'Доступность сайта', description: 'Статус, домен, SSL' },
    { path: '/orders', icon: 'notifications_active', title: 'Уведомления / Заказы', description: 'Скоро подключим push' },
  ];

  const siteIsAvailable = !available?.isNotAvailable;

  return (
    <section className="screen-stack">
      <button type="button" className="status-card" onClick={() => navigate('/available')}>
        <span className={`status-mark ${siteIsAvailable ? 'green' : 'red'}`}>
          <Icon name={siteIsAvailable ? 'check' : 'priority_high'} />
        </span>
        <span className="status-copy">
          <strong>{siteIsAvailable ? 'Сайт доступен' : 'Сайт недоступен'}</strong>
          <small>
            {siteIsAvailable
              ? 'Ваш сайт сейчас доступен для посетителей'
              : available?.content || 'Включена заглушка недоступности'}
          </small>
        </span>
        <span className={`mini-toggle ${siteIsAvailable ? 'on' : ''}`} />
      </button>

      <div className="summary-card">
        <div className="card-title-row">
          <h2>Сводка</h2>
          <button type="button" onClick={() => navigate('/menu')}>Подробнее</button>
        </div>
        <div className="summary-grid">
          <div>
            <Icon name="category" />
            <strong>{stats.categories || '—'}</strong>
            <span>Категорий</span>
          </div>
          <div>
            <Icon name="restaurant" />
            <strong>{stats.items || '—'}</strong>
            <span>Позиций меню</span>
          </div>
          <div>
            <Icon name="campaign" />
            <strong>Push</strong>
            <span>Следующий этап</span>
          </div>
        </div>
      </div>

      <div className="list-card">
        {sections.map((section) => (
          <button
            type="button"
            className="nav-row"
            key={section.path}
            onClick={() => navigate(section.path)}
          >
            <span className="nav-row-icon">
              <Icon name={section.icon} />
            </span>
            <span className="nav-row-copy">
              <strong>{section.title}</strong>
              <small>{section.description}</small>
            </span>
            {section.path === '/orders' ? <span className="pill-badge">12</span> : null}
            <Icon name="chevron_right" className="muted-icon" />
          </button>
        ))}
      </div>
    </section>
  );
};

export default Main;
